<template>

  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Violações de Direitos</b></h5>
      </th>
    </tr>
    <tr>
      <td colspan="4">
        <load v-if="loadingViolacoes"
              mode="table"/>
        <div v-else
             class="col-md-12">

          <b-table
              :fields="[
            {
                key: 'protocolo',
                label: $t('Detalhes'),
            },
            {
                key: 'cadastrado',
                label: $t('Data'),
            },
          ]"
              :items="ViolacoesList"
              :responsive="true"
              hover
              outlined
              show-empty
              small
              stacked="xs"
              striped
              table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              Usuário(s):<br/>
              <ul>
                <li
                    v-for="pessoa in data.item.pessoas_objetos"
                    :key="pessoa.id"
                >
                  <b>{{
                      pessoa.nome_completo
                    }}</b>
                </li>
              </ul>
              Protocolo:
              <b>{{
                  data.item.protocolo
                }}</b>
              <br/>
              Violações:

              <ol>
                <li v-for="item in data.item.violacoes_nomes"
                    :key="item.id">
                  {{ item.descricao }}
                </li>
              </ol>

            </template>
            <template v-slot:cell(cadastrado)="data">
              {{ data.item.cadastrado }}
            </template>

            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Violacoes",
  props: ['familia'],
  data() {
    return {
      ViolacoesList: [],
      tipos: [],
      loadingViolacoes: true,
    }
  },
  mounted() {
    this.getTipos();
    this.getViolacoes();
  },
  methods: {
    getViolacoes() {
      this.loadingViolacoes = true;
      axios
          .get(`api/dashboard/print/usuarios/violacoes/${this.familia}`)
          .then((response) => {
            this.ViolacoesList = response.data.data;
            this.loadingViolacoes = false;
          })
          .catch(() => {
            this.loadingViolacoes = false;
          });
    },
    getTipos() {
      axios
          .get(`api/dashboard/violacaodedireitos/tipos`)
          .then((response) => {
            this.tipos = response.data;
          });
    },
  },
}
</script>

<style scoped>

</style>